import { render } from "./TitleImage.vue?vue&type=template&id=098e9a3a"
import script from "./TitleImage.vue?vue&type=script&lang=ts"
export * from "./TitleImage.vue?vue&type=script&lang=ts"
script.render = render

export default script